<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{title | translate}}</h4>
  </div>
  <div class="modal-body custom-background">
    <form [formGroup]="manageDocumentForm">
      <div class="row">
        <div class="col form-group">
          <label>{{'LABEL.MANAGEMENT-TYPE' | translate}}</label>
          <select class="form-select form-control" formControlName="managementType"
                  [(ngModel)]="managementTypeSelected">
            <option *ngFor="let managementType of managementTypes; let index=index"
                    [ngValue]="managementType">
              {{ 'SELECT.OPTIONS.' + managementType.name | translate }}
            </option>
          </select>
        </div>
        <div class="col form-group mt-2rem">
          <button class="btn btn-outline-success" (click)="reAddRow()" [disabled]="disabledBtnAdd">
            + {{ "BUTTON.ADD" | translate }}</button>
        </div>
      </div>
      <div formArrayName="arrayManagementDocument">
        <div class="form-row" *ngFor="let group  of arrayManagementDocument.controls; let index= index;"
             [formGroupName]="index">
          <div class="col form-group">
            <label>  {{ 'SELECT.OPTIONS.' + group.get('description').value | translate }} {{'LABEL.OF-DOCUMENT' | translate}} </label>
            <input type="number" formControlName="time"
                   [class.is-invalid]="isInvalidControls(index,'time')"
                   placeholder="{{'MESSAGE.ENTER-THE-NUMBER' | translate}}"
                   class="form-control" min="1">
            <small *ngIf="isInvalidControls(index,'time')" class="text-danger">
              {{ getErrorMessage(index, 'time') }}
            </small>
          </div>
          <div class="col form-group">
            <label>{{'LABEL.DURATION' | translate}}</label>
            <select class="form-select form-control" formControlName="dateType">
              <option *ngFor="let dateType of dateTypes" [ngValue]="dateType">
                {{ 'SELECT.OPTIONS.' + dateType.name | translate }}
            </select>
          </div>
          <div class="col-md-1 form-group mt-2rem">
            <div class="dropdown">
              <button type="button" class="btn btn-default " id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item pointer"
                   (click)="delete(index)">
                  <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-outline-success"
            (click)="save()">
      <i class="fa fa-bookmark"></i>  {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>

